import {useCan} from '@/shared/hooks/use-permissions'
import {requirePermission} from '@/modules/auth/permissions'
import {useGetInfiniteSupportiveMedicationDrugs} from '@/modules/drug-catalog/supportive-medications/api'
import {
  SupportiveMedicationsFilters,
  SupportiveMedicationsTable,
} from '@/modules/drug-catalog/supportive-medications/components'
import {SupportiveMedicationsSearchSchema} from '@/modules/drug-catalog/supportive-medications/schemas'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {createFileRoute} from '@tanstack/react-router'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'

export const Route = createFileRoute('/configuration/drug-catalog/supportive-medications/')({
  beforeLoad: requirePermission('catalogue.view'),
  component: SupportiveMedicationsPage,
  validateSearch: SupportiveMedicationsSearchSchema,
})

const LIMIT = 50

function SupportiveMedicationsPage() {
  const canManageCatalogue = useCan('catalogue.manage')
  const search = Route.useSearch()
  const [sort] = search.sort

  const infinite = useGetInfiniteSupportiveMedicationDrugs({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
    filters: {
      status: [],
      categories: search.filters?.categories,
      search: search.filters?.search,
      calculationMethod: search.filters?.calculationMethod,
      unit: search.filters?.unit,
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infinite

  return (
    <>
      <ResourcesIndexPageHeader
        {...(canManageCatalogue ? {addNewTo: '/configuration/drug-catalog/supportive-medications/new'} : {})}
      >
        <SupportiveMedicationsFilters />
      </ResourcesIndexPageHeader>
      <ResourcesIndexPageTable>
        <SupportiveMedicationsTable
          virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
          table={{state: {sorting: search.sort}}}
        />
      </ResourcesIndexPageTable>
    </>
  )
}
